import type { FC } from 'react';
import React, { Fragment } from 'react';

import { ServiceHistoryGap } from './ServiceHistoryGap';
import { ServiceHistoryItem } from './ServiceHistoryItem';
import type { ServiceHistoryRecords } from './ServiceHistoryItems.types';

import styles from './ServiceHistoryItems.module.scss';

interface ServiceHistoryItemsProps {
	serviceHistoryRecords: ServiceHistoryRecords;
}

export const ServiceHistoryItems: FC<ServiceHistoryItemsProps> = ({ serviceHistoryRecords }) => {
	if (!serviceHistoryRecords) {
		return null;
	}

	return (
		<div className={styles.wrapper}>
			{serviceHistoryRecords?.items.map(({ date, dealershipType, gap, id, lapse, mileage }, index) => {
				const isLastRecord = index === serviceHistoryRecords.items.length - 1;
				return (
					<Fragment key={id}>
						<ServiceHistoryItem
							date={date}
							distanceOverdue={lapse.distance}
							mileage={mileage || 0}
							timeOverdue={lapse.time}
							type={dealershipType ?? ''}
						/>
						{!isLastRecord && <ServiceHistoryGap distance={gap.distance} months={gap.time} />}
					</Fragment>
				);
			})}
		</div>
	);
};
